import {Component, Provide, Vue} from 'vue-property-decorator';
import DescriptionsContainer from '@/utils/DescriptionsContainer';

@Component
export default class DescriptionsContainerMixin extends Vue {
    protected descriptionsContainer: DescriptionsContainer | null = null;

    @Provide()
    getDescriptionsContainer() {
        if (this.descriptionsContainer) return this.descriptionsContainer;
        else {
            this.descriptionsContainer = new DescriptionsContainer(this.$http);
            return this.descriptionsContainer;
        }
    }

    addDescriptionPostfix(str: string, postfix: string = 'GetDescriptions') {
        return `${str}/${postfix}`;
    }
}
